import { AssessmentExistsModal } from "@/modules/agent/components/upload-dialog/tpra/AssessmentExistsModal";
import { ArchiveWarningModal } from "@/modules/agent/components/upload-dialog/tpra/ArchiveWarningModal";
import type { ExistingAssessment } from "@/modules/agent/requests/tpra-assessment";

interface AcceptFlowModalsProps {
  modalStep: "none" | "exists" | "archive";
  existingAssessment: ExistingAssessment | null;
  memberHasAccess: boolean;
  archiveConfirmed: boolean;
  isLoading: boolean;
  onClose: () => void;
  onViewAssessment: () => void;
  onStartNew: () => void;
  onBackFromArchive: () => void;
  onToggleConfirm: (confirmed: boolean) => void;
  onArchiveProceed: () => void;
}

export function AcceptFlowModals({
  modalStep,
  existingAssessment,
  memberHasAccess,
  archiveConfirmed,
  isLoading,
  onClose,
  onViewAssessment,
  onStartNew,
  onBackFromArchive,
  onToggleConfirm,
  onArchiveProceed,
}: AcceptFlowModalsProps) {
  if (!existingAssessment) return null;

  return (
    <>
      <AssessmentExistsModal
        isOpen={modalStep === "exists"}
        assessment={existingAssessment}
        memberHasAccess={memberHasAccess}
        onClose={onClose}
        onBack={onClose}
        onViewAssessment={onViewAssessment}
        onStartNew={onStartNew}
      />
      <ArchiveWarningModal
        isOpen={modalStep === "archive"}
        isConfirmed={archiveConfirmed}
        isLoading={isLoading}
        loadingText="Creating assessment..."
        onClose={onClose}
        onBack={onBackFromArchive}
        onToggleConfirm={onToggleConfirm}
        onProceed={onArchiveProceed}
      />
    </>
  );
}
